module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-genio-seleziona-particelle",
      "title": "Seleziona Particelle"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33478022!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/GenioSelezionaParticelle.vue
// module id = 839
// module chunks = 39